const style = theme => ({
  card: {
    margin: '20px auto',
    alignItems: 'center',
  },
})

export default style
